module.exports = __webpack_public_path__ + "static/img/logo-fr.5875cfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-fr.svg
// module id = 3F6x
// module chunks = 15